import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import alertify from "alertifyjs";
import { useMutation } from "@apollo/react-hooks";
import { Loading } from "../components";
import { userMutations } from "../resolvers";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit">Tüm Hakları Saklıdır -</Link>{" "}
      {new Date().getFullYear()}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: "4em",
  },
}));

export default function SignUp() {
  const [initialState, setInitialState] = useState({
    name: "",
    surname: "",
    username: "",

    error: {},
  });
  const classes = useStyles();
  const handleSetInitialState = (newValue) => {
    setInitialState({
      ...initialState,
      ...newValue,
      error: {
        ...initialState.error,
      },
    });
  };

  const handleChange = (event) => {
    setInitialState({
      ...initialState,
      [event.target.name]: event.target.value,
      error: {
        ...initialState.error,
        [event.target.name]: event.target.value ? false : true,
      },
    });
  };
  const resetInitialState = () => {
    setInitialState({
      name: "",
      surname: "",
      username: "",      
      error: {},
    });
  };
  const [signup, { loading }] = useMutation(userMutations.USER_CREATE, {
    onCompleted(data) {
      resetInitialState();
      alertify.success(
        "Parolanız email hesabınıza gönderilmiştir. Lütfen kontrol ediniz.",
        4
      );
    },
    onError(err) {
      //console.log(err);
      let x = err.message.split(":", 2);
      alertify.error(x[1], 3);
    },
  });

  const validate = () => {
    const {
      name,
      surname,
      username,      
    } = initialState;
    setInitialState({
      ...initialState,
      error: {
        name: initialState.name ? false : true,
        surname: initialState.surname ? false : true,
        username: initialState.username ? false : true,       
      },
    });
    return !name || !surname || !username;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      alertify.error("Lütfen Gerekli Alanları Doldurunuz.", 3);
    } else {
      signup({
        variables: {
          data: {
            name: initialState.name,
            surname: initialState.surname,
            username: initialState.username,          
          },
        },
      });
    }
  };

  if (loading) return <Loading />;

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Kayıt Ol
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                onChange={handleChange}
                value={initialState.name}
                error={initialState.error.name}
                autoComplete="fname"
                name="name"
                variant="outlined"
                fullWidth
                id="name"
                label="Adı"
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                onChange={handleChange}
                value={initialState.surname}
                error={initialState.error.surname}
                variant="outlined"
                fullWidth
                id="surname"
                label="Soyadı"
                name="surname"
                autoComplete="lname"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                onChange={handleChange}
                value={initialState.username}
                error={initialState.error.username}
                variant="outlined"
                fullWidth
                id="email"
                label="Email"
                name="username"
                autoComplete="email"
              />
            </Grid>           
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Kaydet
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="signin" variant="body2">
                Kaydın var ise? Buradan Giriş Yap?
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
}
